import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 503 && error.response.data.error === 'maintenance_mode') {
            document.body.innerHTML = `
                <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:100vh; background:#f8fafc; font-family:sans-serif; text-align:center; padding: 20px;">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: 20px;">
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                    </svg>
                    <h1 style="color:#1e293b; margin:0 0 10px 0; font-size: 24px;">Техническое обслуживание</h1>
                    <p style="color:#64748b; font-size:16px; max-width: 400px; line-height:1.5;">Система eDukhtur временно недоступна в связи с установкой обновлений. Пожалуйста, подождите пару минут.</p>
                </div>
            `;
            return new Promise(() => {}); 
        }

        if (error.response && error.response.status === 401) {
            if (window.location.pathname !== '/login') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                
                if (error.response.data && error.response.data.error) {
                    alert(error.response.data.error);
                }
                
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default api;